import { usePath } from "../libs/path/PathProvider";
import { useMemo } from "react";
import Utils from "../portlibs/PortUtils";
import _ from "lodash";
import Dropdown from "../libs/dropdown/Dropdown";

const ValidCurrency = new Set([-1,0,1])
export default function CurrencyFilter(){
    const {query,setQuery} = usePath()
    let current = useMemo(() => Utils.currency, [query])
    if (!ValidCurrency.has(current)) current = -1
    const options = [{value:-1,label:"All"},{value:0,label:"CAD"},{value:1,label:"USD"}]
    const onSelect = (currency:number|null) => setQuery({currency:""+currency}) 
    return <Dropdown onChange={onSelect} value={current} options={options}/>
    // return <Select className="select" onChange={onSelect} value={current}>{items}</Select>
}